export const defaultTitle = 'Our process is clear <br /> <i>from start to finish</i>';
